module.exports = {
  "country": "DE",
  "artist": "Nicole",
  "song": "Ein bisschen Frieden",
  "year": "1982",
  "place": "1",
  "spotify": "5ZSfGGi8OF1vSSVNAWdQT1"
};